<template>
  <div>
    <div class="pageTop">
      <div class="pageWD flex flex-sb">       
        <div class="flex navleft ">        
          <el-menu            
            mode="horizontal"  
                
          >
              <el-menu-item index="1" v-if="compList.length=='1'"><img :src="compDefault.Logo" class="cimg"/><span class="ctext">{{compDefault.companyName}}</span></el-menu-item>
              <el-submenu index="2" v-else >
                <template slot="title"><img :src="compDefault.Logo" class="cimg"/>{{compDefault.companyName}}</template>              
                 <div class="think-items">          
                <el-menu-item :index="(index+'')" v-for="(item,index) in compList" :key="index"   @click.native.prevent="change(item)">{{item.coName}}</el-menu-item>              
                </div>
              </el-submenu>
           </el-menu>   
        </div>
        <div class="flex navright">
          <div class="alink" style="margin-right:20px">
            <!-- <a href="" class="Astore"><i class="el-icon-shopping-cart-1"></i></a> -->
           
            <el-dropdown  v-if="msgList.length!=0" @visible-change="changeMessage($event)">
              <span class="el-dropdown-link">
                <i class="iconfont icon-a-9_xiaoxitongzhi mg" v-if="!isOpen"></i>
                 <i class="iconfont icon-a-9_xiaoxitongzhi mg" v-else style="color:#4b9afb"></i>
              </span>
              <el-dropdown-menu slot="dropdown"  class="project-dropdown">
                <div class="Amessage" v-for="(item,index) in msgList" :key="index">
                  <div class="item" v-if="item.cmMsgcontenttype =='1'" @click="tapMessage(item)">
                    <div class="itit f18 c3">
                      【学习任务】您有一场任务需要完成。               
                    </div>
                    <div class="itext f14 c9">
                      <div>学习任务名称：{{item.taskName}}</div>
                      <div>开始时间：{{$conFun.parseData(item.beginTime)}}</div>
                      <div>创建人：{{item.createdName  }}</div>
                    </div>
                    <div class="ienter f14 c3 flex flex-sb"><span>立即查看</span><i class="el-icon-arrow-right"></i></div>
                  </div>
                  <div class="item" v-if="item.cmMsgcontenttype =='2'" @click="tapMessage(item)">
                    <div class="itit f18 c3">
                      【视频直播】您有一场视频直播任务需要完成。
                    </div>
                    <div class="itext f14 c9">
                       <div>视频直播名称：{{item.taskName}}</div> 
                       <div>开始时间：{{$conFun.parseData(item.beginTime)}}</div>
                       <div>主讲人：{{item.createdName  }}</div>
                    </div>
                    <div class="ienter f14 c3 flex flex-sb"><span>进入直播间</span><i class="el-icon-arrow-right"></i></div>
                  </div>
                  <!-- <div class="item" v-else-if="item.cmMsgcontenttype =='3'">
                    <div class="itit f18 c3">
                      [线下培训]您有一场线下培训任务需要完成。        
                    </div>
                    <div class="itext f14 c9">
                       <div>线下培训名称：{{item.taskName}}</div> 
                       <div>开始时间：{{$conFun.parseData(item.beginTime)}}</div>
                       <div>发起人：{{item.createdName  }}</div>
                    </div>
                    <div class="ienter f14 c3 flex flex-sb"><span>立即查看</span><i class="el-icon-arrow-right"></i></div>
                  </div> -->
                  <div class="item" v-if="item.cmMsgcontenttype =='4'"  @click="tapMessage(item)">
                    <div class="itit f18 c3">
                      【语音直播】您有一场语音直播任务需要完成。        
                    </div>
                    <div class="itext f14 c9">
                       <div>语音直播名称：{{item.taskName}}</div> 
                       <div>开始时间：{{$conFun.parseData(item.beginTime)}}</div>
                       <div>主讲人：{{item.createdName  }}</div>
                    </div>
                    <div class="ienter f14 c3 flex flex-sb"><span>进入直播间</span><i class="el-icon-arrow-right"></i></div>
                  </div>
                   <!-- <div class="item" v-else>
                    <div class="itit f18 c3">
                     {{item.taskName}}              
                    </div>
                    <div class="itext f14 c9">  
                        <div>开始时间：{{$conFun.parseData(item.beginTime)}}</div>                    
                    </div>
                    <div class="ienter f14 c3 flex flex-sb"><span>立即查看</span><i class="el-icon-arrow-right"></i></div>
                  </div> -->
                </div>            
              </el-dropdown-menu>
            </el-dropdown>
            <span class="Aadmin" @click="open">管理后台</span>
            <el-dropdown>
              <span class="el-dropdown-link">
                <span class="mg hoverme">帮助</span>
              </span>
              <el-dropdown-menu slot="dropdown"  class="project-dropdown">
                 <div class="Amessage" v-for="(item,index) in HelpList" :key="index">
                  <div class="item"  @click="tapHelper(item,index)">
                    <div class="itit f18 c3">{{item.giTitle}}</div>
                    <div class="itext f14 c9">
                      {{item.giContext}}
                    </div>                   
                  </div>     
                </div>                      
              </el-dropdown-menu>
            </el-dropdown>
             <el-dropdown>
              <span class="el-dropdown-link">
                <span class="mg hoverme">客服</span>
              </span>
              <el-dropdown-menu slot="dropdown"  class="Acustomer">                
                  <div class="item" ><img src="../assets/images/kefu.png" /></div>                                    
              </el-dropdown-menu>
            </el-dropdown>           
          </div>
          <el-menu           
            mode="horizontal"           
          >
            <el-submenu index="1">
              <template slot="title"
                ><img :src="compDefault.userheadpic" class="userheadpic"
              /></template>              
              <el-menu-item index="2-2" @click.native.prevent="loginout"
                >退出</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="pageNav">
      <div class="pageWD">
        <router-link to="/index" class="nav-link left-home" :class="[isActive=='home'?'is-actived':'']">首页</router-link>
        <router-link to="/Livelist" class="nav-link left-other" :class="[isActive=='live'?'is-actived':'']">直播管理</router-link>
        <router-link to="/Knowledge" class="nav-link left-other" :class="[isActive=='Know'?'is-actived':'']">知识社区</router-link>
        <router-link to="/Think" class="nav-link left-other" :class="[isActive=='Think'?'is-actived':'']">企业智库</router-link>
        <router-link to="/Task" class="nav-link left-other" :class="[isActive=='Task'?'is-actived':'']">学习计划</router-link>
         <router-link to="/Test" class="nav-link left-other" :class="[isActive=='Test'?'is-actived':'']">职业测评</router-link>
      </div>
    </div>
    <el-backtop></el-backtop>
    <AudioTip :isTip="isTip"  @hideMe="hideMeHome" isApp="0"/>
    <!-- <AudioTip :isTip="isTip"  @hideMe="hideMeHome"/> -->
  </div>
</template>

<script>
import { changeQiyes,getMessageList,getHelpList,GetInfo } from '@/api/api'
import AudioTip from "@/components/AudioTip.vue";
import Cookies from "js-cookie";
export default {
   name: "Nav",
   components: { AudioTip },
   props:['isActive','Logo'],   
   data() {
    return {
      isOpen:false,
      isTip:false,
      videoShow:false,
      msgList:[], 
      HelpList:[], 
      compDefault:{
        companyName:'',
        Logo:''
      },
      userInfor:'',
      compList:''    
    };    
  },

  mounted(){ 
    console.log(this.Logo)
    this.compDefault.companyName = Cookies.get('qslCONAME') 
    this.compDefault.Logo = this.Logo?this.Logo:Cookies.get('qslCOLOGO')     
    this.compDefault.userheadpic = Cookies.get('qsluserheadpic')        
    this.getMessageList()
    
     if(typeof(this.compDefault.userheadpic) =='undefined'){ 
      this.getUserInfo()        
    }   

    const qslHelpList = sessionStorage.getItem("qslHelpList");  
    if(qslHelpList){  
      console.log('help for cookies')   
      this.HelpList = JSON.parse(qslHelpList)     
    } else{      
      console.log('help for load')    
      this.getHelpList()     
    }
       

    const qslCompList = sessionStorage.getItem("qslCompList");  
    if(qslCompList){  
      console.log('company for cookies')   
      this.compList = JSON.parse(qslCompList)

    } else{      
      console.log('company for load')    
      this.getCompList()     
    }

  },
  methods: {
     getUserInfo() {
       
      this.$store
        .dispatch("GetInfo")
        .then((res) => {   
          console.log(res.body.result)
          
         	this.compDefault.userheadpic =res.body.result.userheadpic
           
        })
        .catch((err) => {
          console.log(err);
        });
    },
     open(){
      window.open('https://qiye.yunxuekeji.cn/');
    },
    hideMeHome(){
       this.isTip = false
    },
    tapMessage(item){      
        if(item.cmMsgcontenttype =='2'){          
          this.$router.push({ path: this.redirect || "/Live?liId="+item.cmMsgcontentid })       
        }
        if(item.cmMsgcontenttype =='4' || item.cmMsgcontenttype =='1' ){          
          this.isTip = true    
        }
    },
    tapHelper(item,index){
       this.$router.push({ path: this.redirect || "/home/helpcenter?index=" + index +'&id='+item.giId })      
    },
    getCompList(){
        this.$store.dispatch("GetComp").then(res => {                                  
        this.compList = res.body.result      
        sessionStorage.setItem('qslCompList',JSON.stringify(res.body.result));         
      })   
    },   
     getHelpList(){
      var that = this
      let data = {
        pageIndex:1,
        pageSize:10
      };
      getHelpList(data)
      .then(res => {          
        that.HelpList = res.body.result   
        sessionStorage.setItem('qslHelpList',JSON.stringify(res.body.result));        
      })
      .catch(err => {});
    },
    getMessageList(){
      var that = this
      let data = {
        memberId: Cookies.get('qslmemberId'),
        COID: Cookies.get('qslCOID'),
        pageIndex:1,
        pageSize:100
      };
      getMessageList(data)
      .then(res => {
        that.msgList = res.body.result.msgList         
      })
      .catch(err => {});
    },
    change(result) {		
			var that = this;
			if ( Cookies.get('qslCOID') == result.coId) {      
             this.$message({
                  message: '您已在当前大学！'                  
               });  
			     	return;
			} 
      this.$confirm('是否要进入该企业？', '请确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'        
        }).then(() => {
          if (result.cfIsfreeze) {
                this.$message({
                  message: '该企业平台已冻结',
                  type: 'warning'
                });
						
						} else if (result.isPastDue == 1) {
               this.$message({
                  message: '该企业平台已过期',
                  type: 'warning'
               });						
						} else {
							let data = {
								userId: Cookies.get('qsluserId'),
								COID: result.coId
							};
							changeQiyes(data)
								.then(res => {                                      
                  Cookies.set('qslCOID',result.coId)                   
                  Cookies.set('qslCONAME',result.coName)  
                  Cookies.set('qslCOLOGO',result.coLogo) 
                  that.getUserInfo()
                  that.getMessageList()   
								})
								.catch(err => {});
            }    
        }).catch(() => {});  
		},
     getUserInfo() {
      this.$store
        .dispatch("GetInfo")
        .then((res) => {
          Cookies.set('qslmemberId',res.body.result.memberId)    
          Cookies.set('qslmemberName',res.body.result.memberName)             
         	Cookies.set('qsluserheadpic',res.body.result.userheadpic)  
          var CurrentPath = this.$route.path   
          sessionStorage.removeItem("qslHelpList");
          sessionStorage.removeItem("qslCompList");    
          if(CurrentPath =='/index') {              
            window.location.reload()	
          } else{
            this.$router.push({ path: this.redirect || "/index" })   
          }      
          //this.$router.go(0)	           
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeMessage(isOpen){
       this.isOpen = !this.isOpen
    },
    loginout() {
      this.$confirm("确定退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          location.href = "/";
        });
      });
    },
  },
};
</script>

<style scoped>
.pageTop {
  background: #fff;
  height: 86px;
}
.pageNav {
  box-shadow: 0px 20px 20px -20px #ccc;
  height: 56px;
  line-height: 56px;
}
.nav-link {
  color: #666666;
  font-size: 18px;
  padding: 0 20px;
  height: 56px;
  display: inline-block;
  position: relative;
}
>>> .el-submenu__title{
  padding:0
}
.router-link-exact-active,
.nav-link:hover,.is-actived {
  color: #4b9afb;
}
.cimg{ 
  height:52px;
  margin-right:20px;
}
.router-link-exact-active:after ,.is-actived:after{
  content: "";
  height: 8px; 
  width: 24px;
  background: #4b9afb;
  position: absolute;
  bottom: 0;
  border-radius: 4px;
}

/* .navright .is-active:after,.navleft .is-active:after{
  background: transparent;
} */
.left-home:after{
  left: 35%;
}
.left-other:after{
  left: 40%;
}
.alink a {
  color: #666;
  font-size: 18px;
  padding: 0 20px;
  position: relative;
}
.Amessage .item {
  padding: 24px;
  cursor: pointer;
}
.Amessage:hover {
   background: #fff;
    box-shadow: 0px 1px 10px 0px rgba(0,0,0,0.2);
}

.Amessage:hover .itit,.Amessage:hover .ienter{
  color:#4b9afb
}
.Amessage .itit{
  margin-bottom:12px;
  position:relative;  padding-left:24px;
}
.Amessage .itit:after{
  position:absolute;
  content:'';
  left:0px;
  top:5px;
  background:#4b9afb;
  height: 16px;
  width: 8px;
  background: #4b9afb;
  border-radius: 4px;

}
.Amessage .itext{
 line-height: 18px;
}
.Amessage .itext div{
 line-height: 30px;
}
.Amessage .ienter{
 margin-top:15px
}
.alink a.Astore {
  font-size: 22px;
}
.navright .hoverme:hover{
  color: #4b9afb;
}
.alink .Aadmin {
  color: #4b9afb;
  border-radius: 16px;
  border: 1px solid #4b9afb;
  padding: 8px 15px;
  margin: 0 20px;
  cursor: pointer;
}
>>> .el-menu.el-menu-item{
  color:red
}

>>> .el-menu.el-menu--horizontal {
  border: 0;
}
>>> .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{
  border: 0;
}
>>> .el-submenu.is-active .el-submenu__title{
   border: 0;
}
>>> .el-menu--horizontal>.el-submenu .el-submenu__title{
  color:#666;
  font-size:24px
}
.Acustomer
{
    padding: 0;
    width: 128px;
    height: 128px;
    overflow: auto;
    padding:3px 0 0 3px
}
.ctext{
   color:#666;
   font-size:24px
}
>>> .el-menu--horizontal>.el-submenu .el-submenu__title{
  height:52px;
  line-height:52px;
  border:0
}
.navright .el-dropdown{
  font-size: 18px;
  color: #666
}
.navright .mg{
  font-size:20px;margin:0 20px;  cursor: pointer;
}
 >>> .el-dropdown-menu{
  padding:0
}
.project-dropdown{
  padding:0; width:466px; height:450px;
  overflow: auto;
}

 .think-items .el-menu-item{
   height:48px;
   line-height:48px
 }
 .think-items li:hover
{
 
  box-shadow:0px 1px 10px 0px rgba(0,0,0,0.10);
  cursor: pointer;
  background: #fff;
  position:relative;
  z-index:10000
}
.think-items li{
   height:48px;
  line-height:48px;
} 
.think-items .el-menu-item:not(.is-disabled):hover{
 color:#4b9afb;
}
</style>




// WEBPACK FOOTER //
// src/components/Nav.vue